<template>
  <b-modal
    v-model="showTargetCountDetail"
    centered
    title="타겟 인원 상세보기"
    size="lg"
    ok-title="닫기"
    ok-only
    no-close-on-esc
    no-close-on-backdrop
    @close.prevent="close()"
    @ok.prevent="close()"
  >
    <div>
      <b-row>
        <b-col
          md="8"
          class="mb-md-0"
        >
          <span class="text-primary">타겟 인원: <strong>{{ totalTargetCount | $numberFormatter }}명 포함</strong></span>
        </b-col>
      </b-row>
    </div>
    <b-table-simple
      bordered
      responsive
      sticky-header
      class="mt-2"
      style="max-height: 65vh; font-size: 12px;"
    >
      <colgroup>
        <col style="width: 120px">
        <col style="width: 120px">
        <col style="width: 100px">
      </colgroup>
      <b-thead head-variant="light">
        <b-tr>
          <b-th>지역</b-th>
          <b-th>진료과</b-th>
          <b-th>타겟 인원(명)</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(region, rIdx) in data">
          <template v-for="(dept, dIdx) in region.departments">
            <b-tr
              :key="`row-${rIdx}-${dIdx}`"
              :style="region.regionName === '(미분류제외) 전체 합' ? 'background-color: rgba(127, 127, 255, 0.1);' : ''"
            >
              <b-td
                v-show="dIdx === 0"
                :rowspan="(region.departments.length) + 1"
              >
                {{ region.regionName }}
              </b-td>
              <b-td>
                {{ dept.medicalDepartmentName }}
              </b-td>
              <b-td>
                {{ dept.count | $numberFormatter }}
              </b-td>
            </b-tr>
          </template>
          <b-tr
            :key="`total-${rIdx}`"
            class="h6 font-weight-bolder"
            style="background-color: rgba(127, 255, 127, 0.1);"
          >
            <b-td
              style="text-align: center;"
            >
              {{ region.regionName === '(미분류제외) 전체 합' ? '전체 합계' : '지역별 소계' }}
            </b-td>
            <b-td>
              {{ region.regionTotalCount | $numberFormatter }}
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </b-modal>
</template>

<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'
import {
} from '@vue/composition-api'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    showTargetCountDetail: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    totalTargetCount: {
      type: Number,
      default: 0,
    },
  },

  setup(props, { emit }) {
    const close = () => {
      emit('close')
    }
    return {
      close,
    }
  },
}
</script>
